import React from 'react';
import type { LibraryWorkoutsApi } from '../../hooks/useLibraryWorkouts';
import { WorkoutsToolbarDesktop } from './WorkoutsToolbarDesktop';
import { WorkoutsTableDesktop, type WorkoutsTableDesktopProps } from './WorkoutsTableDesktop';
import { WorkoutsSearchMobile } from './WorkoutsSearchMobile';
import { WorkoutsTableMobile, type WorkoutsTableMobileProps } from './WorkoutsTableMobile';

export type WorkoutsTabDesktopProps = {
  activeTab: string;
  wk: LibraryWorkoutsApi;
} & Omit<WorkoutsTableDesktopProps, 'wk'>;

/** Library Workouts tab — desktop slice (R6). */
export function WorkoutsTabDesktop({ activeTab, wk, ...tableProps }: WorkoutsTabDesktopProps) {
  if (activeTab !== 'workouts') return null;

  return (
    <>
      <WorkoutsToolbarDesktop wk={wk} activeTab={activeTab} />
      <WorkoutsTableDesktop wk={wk} {...tableProps} />
    </>
  );
}

export type WorkoutsTabMobileProps = {
  activeTab: string;
  wk: LibraryWorkoutsApi;
} & Omit<WorkoutsTableMobileProps, 'wk'>;

/** Library Workouts tab — mobile search + table (R7). */
export function WorkoutsTabMobile({ activeTab, wk, ...tableProps }: WorkoutsTabMobileProps) {
  if (activeTab !== 'workouts') return null;

  return (
    <>
      <WorkoutsSearchMobile wk={wk} />
      <WorkoutsTableMobile wk={wk} {...tableProps} />
    </>
  );
}
